import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { TableTitleSelection } from './TableTitleSelection';
import { TableTitleWithActions } from './TableTitleWithActions';

type Props = {
  borderless?: boolean;
};

export const TableTitle = (props: Props) => {
  const ctxProps = useTableContextSelectors({
    selectionActive: (s) => s.selectedRows.size > 0,
    description: prop('description'),
  });
  // There is quite complex padding logic. This is on purpose to make
  // both all combinations of [Selection/WithActions, description yes/no]
  // look good and reflect Figma design, considering that TableTitleSelection
  // has dark background.
  return (
    <div className='pb-xs'>
      {ctxProps.selectionActive ? (
        <TableTitleSelection borderless={props.borderless} />
      ) : (
        <TableTitleWithActions />
      )}
      {ctxProps.description && (
        <div
          className={classNames(
            'px',
            ctxProps.selectionActive ? ' py-xs' : 'pb-xs',
          )}
        >
          {ctxProps.description}
        </div>
      )}
    </div>
  );
};
